import { Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { serviceApi } from "../../API/Api";
import ServiceCardItem from "./ServiceCardItem";
import { tokens } from "../../../store/tokens";

const gridContainer = { hidden: {}, visible: { transition: { staggerChildren: 0.08 } } };
const gridItem = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4 } } };

const sectionTitleSx = {
  fontFamily: tokens.font.heading,
  fontWeight: tokens.type.h2.fontWeight,
  letterSpacing: tokens.type.h2.letterSpacing,
  fontSize: { xs: "1.7rem", md: tokens.type.h2.fontSize },
  lineHeight: tokens.type.h2.lineHeight,
  color: tokens.textOn.light.primary,
};
const sectionSubtitleSx = {
  fontFamily: tokens.font.body,
  fontSize: tokens.type.body1.fontSize,
  lineHeight: tokens.type.body1.lineHeight,
  color: tokens.textOn.light.secondary,
  maxWidth: 560,
};
const primaryButtonSx = {
  borderRadius: `${tokens.button.radius}px`,
  height: tokens.button.height.lg,
  px: `${tokens.button.paddingX.lg}px`,
  fontFamily: tokens.font.body,
  fontWeight: tokens.type.button.fontWeight,
  fontSize: tokens.button.fontSize.lg,
  textTransform: tokens.type.button.textTransform,
  bgcolor: tokens.bg.brand,
  color: tokens.color.white,
  boxShadow: "none",
  transition: "background-color 0.2s ease",
  "&:hover": { bgcolor: tokens.bg.brandDark },
};

const TrendingServices = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(serviceApi)
      .then((res) => res.json())
      .then((result) => {
        setData(result.slice(0, 4));
      });
  }, []);

  return (
    <Box mt={{ xs: 6, md: 8 }}>
      <Stack
        component={motion.div}
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5 }}
        justifyContent="center"
        alignItems="center"
        sx={{ px: 2, textAlign: "center", gap: 1.25, mb: { xs: 3, md: 4 } }}
      >
        <Typography sx={sectionTitleSx}>Popular services</Typography>
        <Typography sx={sectionSubtitleSx}>
          Discover the most viewed and all-time top-selling services from our
          expert community.
        </Typography>
      </Stack>

      <Container sx={{ mt: 1 }}>
        <Grid
          container
          spacing={2}
          component={motion.div}
          variants={gridContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {data.map((item, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={item.service_refer ?? index}
              component={motion.div}
              variants={gridItem}
              whileHover={{ y: -4 }}
            >
              <ServiceCardItem data={item} />
            </Grid>
          ))}
        </Grid>

        <Stack direction="row" justifyContent="center" mt={{ xs: 3, md: 4 }}>
          <Button
            component={motion.button}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
            variant="contained"
            onClick={() => navigate("/servicelist")}
            sx={primaryButtonSx}
          >
            Load more
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default TrendingServices;